import { observer } from 'mobx-react';
import * as React from 'react';
import * as _ from 'lodash';
import { styled } from '../theme';
import { useLayerManager } from '../hooks/useLayerManager';
import { useCallback, useEffect } from 'react';
import { css } from '@emotion/react';
import { Keys, useKeyPress } from '../hooks/useKeyPress';
import { useForceUpdate } from '../hooks/useForceUpdate';

export const LayersWidget: React.FC = observer(() => {
  const layerManager = useLayerManager();
  const forceUpdate = useForceUpdate();

  useEffect(() => {
    return layerManager.registerListener({
      update: () => {
        forceUpdate();
      }
    });
  }, []);
  const handleKeypress = useCallback(() => {
    const layer = _.last(layerManager.getLayers());
    if (layer?.userCanExit()) {
      layer?.dispose();
    }
  }, []);

  useKeyPress(Keys.ESCAPE, {
    onKeyPressed: () => {
      handleKeypress();
    }
  });

  return (
    <S.Container>
      {_.map(layerManager.getLayers(), (layer, zIndex) => {
        return (
          <S.Layer
            key={layer.id}
            clickThrough={layer.clickThrough}
            zIndex={zIndex + 1}
            withBackdrop={layer.options.withBackdrop}
          >
            {layer.options.render({
              index: zIndex,
              layer: layer,
              handler: null as any
            })}
          </S.Layer>
        );
      })}
    </S.Container>
  );
});

export const LAYER_ANIMATION_DURATION = 500;
const BASE_LABEL = 'layers-widget';
namespace S {
  export const Container = styled.div`
    label: ${BASE_LABEL};
    position: relative;
  `;

  export const Layer = styled.div<{ zIndex: number; clickThrough?: boolean; withBackdrop?: boolean }>`
    label: ${BASE_LABEL}__layer;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: ${(p) => p.zIndex};
    transition: opacity ${LAYER_ANIMATION_DURATION / 1000}s;
    background-color: ${(p) => (p.withBackdrop ? 'rgba(0, 0, 0, 0.3)' : 'transparent')};
    ${(p) =>
      p.clickThrough
        ? css`
            pointer-events: none;
          `
        : ''}
  `;
}
